import React from 'react';
import {
    TypographyBody,
    Styler,
    Divider2,
    FlexGrid2,
    InformationIcon,
    SvgIconProps,
    useBreakpoints,
} from '@honeycomb/ui-core';
import { useGlobalContext } from '@honeycomb/data';
import { NetflightsAtolLogo } from './images/logos/NetflightsAtolLogo';
import { NetflightsPhoneIcon } from './images/logos/NetflightsPhoneIcon';
import { TrustpilotLogo } from './images/logos/TrustpilotLogo';
import { NetflightsAbtaLogo } from './images/logos/NetflightsAbtaLogo';

type HotelSrpUspsProps = {
    title: string;
    text: string;
    icon?: React.ReactElement<SvgIconProps>;
    href?: string;
    type?: string;
};

type Icon = {
    name: string;
    component: React.ReactElement<SvgIconProps>;
};

const icons: Icon[] = [
    { name: 'atol', component: <NetflightsAtolLogo size="2xl" id="AtolIcon" /> },
    { name: 'telephone', component: <NetflightsPhoneIcon size="2xl" id="telephoneIcon" /> },
    { name: 'trustpilot', component: <TrustpilotLogo height="100%" id="trusuPilotIcon" /> },
    { name: 'abta', component: <NetflightsAbtaLogo size="2xl" height="100%" id="AbtaIcon" /> },
];

export function HotelSrpUsps() {
    const {
        resourceStrings: { SEARCH_USP_1, SEARCH_USP_2, SEARCH_USP_4 },
    } = useGlobalContext();

    const { mediumOnly } = useBreakpoints();

    const resources: string[] = [SEARCH_USP_1 || '', SEARCH_USP_2 || '', SEARCH_USP_4 || ''];
    const usps: HotelSrpUspsProps[] = [];

    resources.forEach((resource) => {
        const values = resource.split('|');

        if (values.length === 4) {
            const [type, title, text, iconName] = values;
            const icon = icons.find((item) => item.name === iconName)?.component || <InformationIcon size="2xl" />;
            usps.push({
                title,
                text,
                icon,
                type,
            });
        }
    });

    const gridProps = mediumOnly
        ? {
              justifyContent: 'space-evenly',
          }
        : {
              alignItems: 'center',
          };

    return (
        <FlexGrid2 container={true} {...gridProps}>
            {usps.map((usp, index) => {
                const { title, text, icon: IconComponent } = usp;
                return (
                    <React.Fragment key={`usp-${index.toString()}`}>
                        <FlexGrid2>
                            <FlexGrid2
                                container={true}
                                flexDirection="column"
                                alignItems="center"
                                id={`usp-${title}-image`}
                            >
                                <Styler c="text.heading" mb={3} ta="center" h={48}>
                                    {IconComponent}
                                </Styler>
                                <TypographyBody
                                    weight="bold"
                                    component="h5"
                                    size="2xl"
                                    id={`usp-${title}`}
                                    my={4}
                                    color="text.heading"
                                    mb={2}
                                    align="center"
                                >
                                    {title}
                                </TypographyBody>
                                <TypographyBody color="primary.base" size="m" id={`usp-${title}-text`} ta="center">
                                    {text}
                                </TypographyBody>
                            </FlexGrid2>
                            {index < usps.length - 1 && !mediumOnly && <Divider2 my={8} p={8} />}
                        </FlexGrid2>
                        {index < usps.length - 1 && mediumOnly && (
                            <FlexGrid2>
                                <Divider2 orientation="vertical" />
                            </FlexGrid2>
                        )}
                    </React.Fragment>
                );
            })}
        </FlexGrid2>
    );
}
